import { ReactSetupCropYearDialog } from "@omnia/shared/fields/cropYear/SetupCropYearDialog";
import { IOmniaCommand, IOmniaShell, LocaleString } from "../omnia";
import { IFieldsService } from "../types";

export class SetupCropYearCmd implements IOmniaCommand {


    text: string = "Set up crop year" as LocaleString;
    icon: string = "calendar";

    foreground: boolean = false;

    constructor(public fieldSvc: IFieldsService, public shell: IOmniaShell) {

    }

    canExecute(): boolean {

        const { shell, fieldSvc } = this

        if (shell.isReadOnly(p => p.fields)) {
            return false
        }

        const year = fieldSvc.yearId

        // Enable if there is at least one field with no cropping on the current year

        if (fieldSvc.fields.some(f => (!f.disabled) && f.croppings.every(c => c.yearId !== year))) {
            return true
        }

        return false
    }

    execute() {

        this.shell.showComponentAsDialog(
            ReactSetupCropYearDialog,
            null,
            {
                size: "lg"
            }
        );

    }


}
